module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA17.w.0.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA17"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.18.0.0.box.409.352.761.364.q.80"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA17.w.0.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_heading",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "id": "para.18.0.0.box.772.352.34.78.q.60"
    }
  }, [_vm._v("I")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA17.w.0.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_heading",
    attrs: {
      "id": "para.18.0.1.box.409.566.761.150.q.90"
    }
  }, [_vm._v("MY MEETING WITH NIEMOELLER")])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.18.1.0.box.193.912.1202.1239.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA17.w.1.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.18.1.0.box.199.912.1191.89.q.50"
    }
  }, [_c('b', [_c('a', {
    attrs: {
      "id": "GBS.PA17.w.1.0.0"
    }
  }), _vm._v("\"I")]), _vm._v(" HEARD some one scream, 'You murderer!"), _c('a', {
    attrs: {
      "id": "GBS.PA17.w.1.1.0"
    }
  }), _vm._v(" You murderer! I don't want to die.'")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA17.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.18.1.1.box.193.1021.1202.859.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA17.w.1.2.0"
    }
  }), _vm._v("\"It was my first night in Ploetzensee prison. This bloodcurdling screaming had been going on for hours, it seemed to me. When the dawn came, I heard the terrible, monotonous tolling of a bell. Noise coming from the prison yard caused me to look out of my cell window. A number of men were crossing the yard to the opposite wall. A prisoner in brown uniform, with his hands tied behind him, was being dragged along bodily by two giant guards. He struggled feebly, and his body was crumpled like a half-empty sack. Behind them walked a man whom I knew to be the executioner. He was short, but strongly built. He was dressed in formal clothes—frock coat and top hat. At his side walked an assistant carrying an ax that glistened in the weak light of dawn. And then came a priest, and the judge and the prosecutor, both in formal black. I thought of them as being the bodyguards of death.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA17.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.18.1.2.box.196.1888.1195.263.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA17.w.1.3.0"
    }
  }), _vm._v("\"At the opposite wall the procession halted, and I could see a block being released from the wall. It came down slowly, until it rested on the ground. Now the condemned man, resisting violently, was thrown to his knees by the guards. Then his head was thrust on the block. A moment"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA18.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.19.1.0.box.196.293.1193.143.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA18"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA18.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA18.w.1.0.0"
    }
  }), _vm._v("\nlater I saw the ax flashing down, and I heard the sound of a blow. A stream of blood gushed out, and the severed head fell into the sand. The execution was finished.\"")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA18.w.1.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA18"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.19.1.0.box.193.293.1200.1834.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA18.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "102%",
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.19.1.1.box.195.457.1198.590.q.60"
    }
  }, [_vm._v("Pastor Niemoeller's face was gray, like dank moss one sees in the woods. He paused, as if gathering strength to go on. We were in the yard of Moabit prison, taking our exercise, with the watchful eyes of the guard upon us. The dead sound of shuffling feet walking round and round in a small circle mocked the lone bird singing in a linden tree in the middle of the yard. Presently it took wing and soared out of sight. Pastor Niemoeller was whispering again. He, too, had heard the bird, and had stopped to catch the song. His voice came audibly, for in prison whispering becomes an art, and one's ears become attuned to catch even the faintest sigh.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA18.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "102%",
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.19.1.2.box.193.1055.1196.527.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA18.w.1.2.0"
    }
  }), _vm._v("\"I cannot describe my feelings when I saw all this,\" he said, \"especially as I knew that I was charged with high treason, for which death is the punishment. It became clear to me that I had been brought to this particular cell [in Ploetzensee prison] with deliberate intent. They wanted me to see the execution—to break my will. I must confess that for a moment I nearly gave way. I—I dreaded the ax—dying like that. But it was only for a moment. Strength is given to us at such times. I prayed, prayed for a long time, and the strength came to me. After a week I was transferred here.\"")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA18.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "102%",
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.19.1.3.box.193.1592.1195.316.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA18.w.1.3.0"
    }
  }), _vm._v("Then he fell silent, and I could hear again the dull sound of shuffling feet. I think I shall always hear that sound. It comes to me above the shrill noises of the street, above the roar of the subway. And the pasty-faced, broken men, marching round and round, I shall see always in my dreams as long as I am alive to dream.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA18.w.1.4.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "102%",
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.19.1.4.box.193.1919.1194.208.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA18.w.1.4.0"
    }
  }), _vm._v("The Nazi racial doctrine had stopped at the prison door, at the gate to the concentration camp—a bit of irony that had not then made the tiniest cut on Hitler's thick veneer. Martin Niemoeller, whose ancestry is of the purest origin"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA19.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.20.1.0.box.194.306.1197.970.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA19"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA19.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA19.w.1.0.0"
    }
  }), _vm._v("\naccording to the Nazi creed, and I, a member of an outcast people, had been brought together in the same prison by that same decree. I little realized at our first meeting that it was to be the beginning of a close intimacy that would extend over a period of nearly two years and enable me to give to the world this inside story of the persecution and suffering of this beloved pastor. Outside, the Jew was being walled in from the rest of the world, or being systematically exterminated. Here there was no distinction between Aryan and Jewish victims of Nazi hate and fear. But one could not reflect then. Life was reduced to its starkest realities. Blood was on every street, on the thresholds of thousands of homes in every city in Germany, and there was no one to dam the flow. Law had been thrown to the dungheap. Rule was by personal fiat. Whether the headsman's ax was to be sharpened for me I could not tell. Pain gnawed at my stomach, and there were moments when I could hear the thumping of my heart.")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA19.w.1.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA19.w.1.1.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA19.w.1.2.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA19"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.20.1.0.box.194.306.1198.1836.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA19.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.20.1.1.box.248.1286.716.44.q.60"
    }
  }, [_vm._v("But let us go back to the beginning.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA19.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.20.1.2.box.194.1341.1198.801.q.60"
    }
  }, [_vm._v("It was on a bright morning in midsummer that Pastor Niemoeller and I were first brought together. A few rays penetrating the gloom of my cell brought me news that the sun was shining. On the Wilhelmstrasse, I knew, the grass would be green, and the birds would be singing in the lindens. They still would be free, happily unaware of the terror and anguish beneath them. A guard opened my cell and informed me that I would not go into the prison yard for recreation. I knew at once what this meant. I was to go before an inquisitorial court, before a judge who was also a prosecutor. Shortly after 9 o'clock the guard came to take me down to the great hall of the prison, from where an assistant guard took me to the anteroom of the court of the political department. A number of prisoners were already in the antechamber. Among them was a former Nazi, who,"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA20.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.21.1.0.box.191.293.1193.369.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA20"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA20.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA20.w.1.0.0"
    }
  }), _vm._v("\naccording to his loudly-voiced story, had been the chief of the Gestapo in Berlin. He had been arrested because of his connection with Captain Ernst Roehm, victim of the bloody purge of 1934, and was still awaiting trial. He had lost none of his arrogance. Perhaps he was trying to bolster himself for the coming ordeal. Now he was telling the other prisoners of his importance, of what he had done to further the Nazi power.")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA20.w.1.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA20"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.21.1.0.box.191.293.1193.1822.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA20.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.21.1.1.box.192.672.1190.420.q.60"
    }
  }, [_vm._v("\"You,\" he said to the white-faced group near him, \"are mere criminals, vermin to be trodden under foot. But I am a personage. For me there will be only a life term or death, for I am dangerous. I know too much. But that does not matter. I am still a fervent Nazi. The worst thing that can happen to me is happening now, when I am compelled to be sitting among Jews, all staring at me. I will complain of this to the judge, you swine.\"")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA20.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.21.1.2.box.192.1102.1189.205.q.40"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA20.w.1.2.0"
    }
  }), _vm._v("Perhaps he was mad, for the grave knows no difference between Aryan and Jew, and in the end their dust is mingled together. And I, a Jew, could have reminded him of the teachings of another Jew.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA20.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.21.1.3.box.192.1318.1190.475.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA20.w.1.3.0"
    }
  }), _vm._v("A few feet away sat a man whom I had not noticed before. He must be a new prisoner, I thought, and I was ready to avert my eyes. But suddenly it came to me that I had seen him somewhere before. I looked at him more closely, trying at the same time not to attract his attention. His body slouched forward, he was resting his arms on a windowsill, holding his head in his hands. He looked haggard. His eyes half closed, he seemed to be suffering from exhaustion. I strained my memory in vain. I could not recognize him.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA20.w.1.4.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.21.1.4.box.192.1803.1188.312.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA20.w.1.4.0"
    }
  }), _vm._v("The room and prisoners faded away like an illusion while I continued to gaze at the haunting face. It had a spiritual quality that touched off a spark in my own soul. From the outer blackness came again the voice of the Nazi: \"Jews . . . parasites . . . bloodsuckers . . . Now, Goebbels said to me . . .\" There was a nervous shuffling of feet. A prisoner near me"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA21.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.22.1.0.box.194.306.1194.154.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA21"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA21.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA21.w.1.0.0"
    }
  }), _vm._v("\nsighed heavily. But my eyes were held by the man at the window. He had half turned at the noise. I saw the aspect painters have given the Christian martyrs.")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA21.w.1.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA21.w.1.1.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA21.w.1.2.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA21"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.22.1.0.box.193.306.1200.1836.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA21.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.22.1.1.box.194.470.1198.207.q.50"
    }
  }, [_vm._v("Then, suddenly, I knew. The man was Martin Niemoeller. Now I remembered where I had seen him—in the pulpit of a church in Dahlem. He was the leading force of the German Evangelical Church. He had dared challenge Hitler.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA21.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.22.1.2.box.193.687.1200.1282.q.60"
    }
  }, [_vm._v("The tragic lines around his sensitive mouth and the dark depth of his eyes touched me, drew me into some sort of fellowship with him, into a vague understanding that I could not quite fathom then. The lines in his face had not been engraved by physical suffering alone. They were more the telltale marks of spiritual anguish. I remembered his fighting sermons, that he had remained steadfast to his faith in spite of the growing menace of Nazi might and the appeals of former friends who would have saved his body at the expense of his soul. Many of them had sought shelter in the refuge provided by Alfred Rosenberg, doctrinaire of the new church, the church which would make full obeisance to the new lord. I recalled something of all this, but as I had been arrested a year before, I had not been able to keep up with the development of the battle between the revived paganism and the old faith. The only newspapers I had been allowed to read after my arrest were the "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Voelkischer ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Beobachter ")]), _vm._v("and the "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Angriff, ")]), _vm._v("neither of which, of course, mentioned the struggle between Pastor Niemoeller and Hitler. Before my arrest I had kept pace with the news. Now we could read only the Nazi propaganda. My interest had been partly because of my profession. I was a lecturer on law, and as in Germany churches are public institutions and subject to government regulations, my lectures included also church law.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA21.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.22.1.3.box.194.1989.1195.153.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA21.w.1.3.0"
    }
  }), _vm._v("It was because of my interest in church law and in the tremendous spiritual struggle between the Rosenberg fabrication and the German Evangelical Church that I had gone,"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA22.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.23.1.0.box.193.294.1195.912.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA22"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA22.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA22.w.1.0.0"
    }
  }), _vm._v("\nin company with a friend, to hear Pastor Niemoeller preach. Dahlem is a fashionable suburb of Berlin, and Niemoeller's congregation consisted largely of retired army and navy officers and government officials, who belonged to the conservative school. Listening to him, I had been struck with Niemoeller's religious consistency, the stem purity of his faith, and his spiritual approach to the tragic problems then confronting Church arid State. I had come to look upon him as not only a great Protestant pastor, but as a living symbol of Christianity and humanity. Jews in general looked upon him as a representative of all that was best in German culture and tradition. Though I was already sunk in misery and despair, seeing him in prison shocked me and brought me a new awareness of my own peril. If the Nazis could deliberately lay a famous U-boat commander on their altar of blood and soil, what would they not do to those who have always been the first victims of savagery and lust?")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA22.w.1.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA22"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.23.1.0.box.193.294.1196.1833.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA22.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.23.1.1.box.194.1216.1194.248.q.60"
    }
  }, [_vm._v("The prison hall was silent now. All the other prisoners had been taken before the inquiring judge, and Niemoeller and I were alone. I was very anxious to talk with him, but I felt that the situation was too embarrassing for me to make the first move.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA22.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.23.1.2.box.194.1486.1193.207.q.50"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA22.w.1.2.0"
    }
  }), _vm._v("Presently, however, Niemoeller came over to me and laid a gentle hand on my shoulder. \"You are a Jew,\" he said. \"Don't mind what that Nazi said. He doesn't know what he's talking about—to utter such nonsense.\"")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA22.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.23.1.3.box.193.1704.1196.260.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA22.w.1.3.0"
    }
  }), _vm._v("He was interrupted by a sharp command. The guard had come to take him before the judge. His unexpected kindness had left me speechless, and I sat groping in mental darkness, wondering what the end would be. I could only wait, with four blank walls closing down on me.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA22.w.1.4.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.23.1.4.box.195.1974.1192.99.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA22.w.1.4.0"
    }
  }), _vm._v("Then came my summons, and the guard escorted me into the judge's chamber.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA22.w.1.5.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.23.1.5.box.245.2083.1141.44.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA22.w.1.5.0"
    }
  }), _vm._v("By now I was mentally alert again, and as I entered the"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA23.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.24.1.0.box.191.294.1196.480.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA23"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA23.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA23.w.1.0.0"
    }
  }), _vm._v("\nchamber I immediately fastened my eyes on the judge, seated at a desk before me, trying to catch in his face something of what had transpired between him and Pastor Niemoeller and of what was in store for me. It was Judge Walter, whom I had encountered in an earlier inquisition. As always, he was elegantly dressed and sartorially correct to the last detail. In his lapel was an unusually large swastika, such as generally worn by Nazi officials. Perhaps it is a measure of their self-importance.")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA23.w.1.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA23.w.1.1.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA23.w.1.2.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA23"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.24.1.0.box.191.294.1197.1829.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA23.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.24.1.1.box.193.783.1193.208.q.50"
    }
  }, [_vm._v("I advanced to within a few paces of the desk, bowed, and said, \"Good day, "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Herr ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Amtsgersichtsrat ")]), _vm._v("(Mr. Counselor of the District Court).\" How many times before I had given him that friendly greeting!")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA23.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.24.1.2.box.191.1000.1194.196.q.60"
    }
  }, [_vm._v("\"Heil Hitler,\" he replied importantly, at the same time making the Nazi salute. \"You are addressing Judge Walter,\" which I already knew. Then, icily suave, \""), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Herr ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Doktor, ")]), _vm._v("be seated.\"")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA23.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.24.1.3.box.193.1217.1194.207.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA23.w.1.3.0"
    }
  }), _vm._v("I proceeded to a chair, and sat down, and the guard who had escorted me in left the room. On one side of the desk sat a male secretary, pencil poised to take stenographic notes of the hearing.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA23.w.1.4.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.24.1.4.box.193.1434.1195.528.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA23.w.1.4.0"
    }
  }), _vm._v("Judge Walter ruffled through some papers on his desk, and then cleared his throat. \""), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Herr ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Doktor")]), _vm._v("\" he began pompously, \"it is my duty to inform you that the attorney for the Reich at the People's Court has investigated the charge of high treason brought against you, and has decided to drop it for lack of evidence. Of the many witnesses who were questioned, only one made such statements as would tend to convict you. But there are impelling reasons to doubt his veracity. I congratulate you. You are lucky. You see, there is still justice in the Third Reich, even for the Jews!\"")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA23.w.1.5.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.24.1.5.box.192.1972.1196.98.q.50"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA23.w.1.5.0"
    }
  }), _vm._v("My heart leaped. I was to be freed. I would see again what was beyond those windows—return to the arms of my wife.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA23.w.1.6.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.24.1.6.box.244.2080.1142.43.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA23.w.1.6.0"
    }
  }), _vm._v("\"But,\" the icy voice went on, \"there remains a charge"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA24.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.25.1.0.box.191.295.1190.205.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA24"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA24.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA24.w.1.0.0"
    }
  }), _vm._v("\nagainst you of failing to live up to the commands of our Fuehrer and other members of the government. About this I will question you some other day. You will now read and sign the stenographic report.\"")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA24.w.1.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA24"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.25.1.0.box.191.295.1194.1336.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA24.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.25.1.1.box.241.510.864.44.q.70"
    }
  }, [_vm._v("Then I was led away, stunned and hopeless.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA24.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.25.1.2.box.192.565.1193.635.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA24.w.1.2.0"
    }
  }), _vm._v("As I was to learn later, the man who had testified falsely against me, whose testimony would have sent me to the executioner's block if there had been sufficient perjury to support it, was a man whom the Gestapo had sent as a spy to my lectures. He had been confronted with some of my students, evidently still friendly to me, who had directly contradicted his statements. The investigation which followed showed him to have been a thief and embezzler, so that no word of his could have carried weight. That was why the attorney for the Reich had dropped the more serious charge against me. It was not because the Third Reich was interested injustice towards the Jews, as Judge Walter had boasted.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA24.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.25.1.3.box.191.1211.1190.260.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA24.w.1.3.0"
    }
  }), _vm._v("The new charge against me concerned implied criticisms of the Nazi regime in my lectures on law, which had been based on the general law of the land before Hitler came to power. If convicted of this new \"crime\" I could be sentenced to one to five years in prison.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA24.w.1.4.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.25.1.4.box.193.1481.1188.150.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA24.w.1.4.0"
    }
  }), _vm._v("I was returned to my cell. In a cell near by, as I was soon to learn, was the man who was to be my stay and comfort through many harrowing experiences, Pastor Niemoeller.")])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA25"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA25.w.0.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA25.w.0.0.0.1"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-58621dec","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/content/content-0009.vue
// module id = 66
// module chunks = 0